// @ts-nocheck

export const localeCodes =  [
  "en",
  "fr",
  "nl",
  "de",
  "es",
  "it",
  "pl",
  "ko",
  "uk"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_a5eb2e48",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_eaa12b2e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_06920cea",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_42a109b0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_18cdc699",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_7a513b1b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_3ac0db95",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_fe183830",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_ae753b26",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_2fafdc55",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_316a04ee",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_eac2f3fd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_f925a476",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_19fa9e97",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_d99179ce",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_cb217eb1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_2ad75cf9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_72c2c910",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_2e654ff7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_733ff0d8",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_0e2c648e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_7f46b0a7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_0b3a5545",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_1f5174b3",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_3f40ee22",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_e5b45ff8",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_754047d6",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_a2cc09d6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_4f35aee2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_b3bfe70b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_adda2564",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_7a5ed64e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_1ec36949",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_f6773526",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_6fec14f1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_947abf87",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_c8a9d9c6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_fc71e85a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_b945340d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_516986ad",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_653475e4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_71840512",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_014fca79",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_be359e46",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_9742b4f1",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_8ba2f48e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_7d73cd91",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_3c3c3bda",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_83519cc9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_1def25ba",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_591652e7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_3f1beb05",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_af062d65",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_95e6b530",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_08b00394",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_1455304b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_209a0bce",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_f66c9c16",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_9592fbc2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_3fbbf5d2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_e10a9d90",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_dcd40094",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_2d22059d",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_947e364c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_dd5344a7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_a1628713",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_ae68ffe7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_0ed45b9b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_f1f3dcc7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_5eded83f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_d83d8bc6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_c2342af9",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_ba566293",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_bb69be7a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_bbac625c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_b56f5fb6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_81a80d67",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_8359a86c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_0c5535af",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_e9e84b27",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_f522e02d",
      load: () => Promise.resolve({}),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/2f5d50fb" /* webpackChunkName: "config_i18n_46config_46ts_2f5d50fb" */)
]
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "fr",
    name: "Français",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "nl",
    name: "Nederlands",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "de",
    name: "Deutsch",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "es",
    name: "Español",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "it",
    name: "Italiano",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "pl",
    name: "Polski (Beta)",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "ko",
    name: "한국어",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "uk",
    name: "Українська",
    language: undefined,
    domains: [],
    defaultForDomains: []
  }
]

